import { Box } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';

import { ActivityKindEnum, TransactionTypeEnum } from '../../types/enums';
import type { PropertyAdEditorFormValues } from '../../types/propertyAdEditor';

import { EditorSection } from './EditorSection';
import { EditorSelectField } from './fields';
import { PROPERTY_AD_EDITOR_PROPERTY_KIND_OPTIONS } from './propertyAdPropertyKinds';
import { usePropertyAdEditorNormalization } from './usePropertyAdEditorNormalization';

const activityOptions = [
  { label: 'Sale', value: ActivityKindEnum.Sale },
  { label: 'Rent', value: ActivityKindEnum.Rent },
] as const;

const transactionTypeOptions = [
  { label: 'Ready', value: TransactionTypeEnum.Ready },
  { label: 'Resale', value: TransactionTypeEnum.Resale },
  { label: 'Distress', value: TransactionTypeEnum.Distress },
] as const;

export const PropertyDetailsSection = () => {
  const { control } = useFormContext<PropertyAdEditorFormValues>();
  const activityKind = useWatch({ control, name: 'activityKind' });
  const { changeActivity, changePropertyKind, changeTransactionType } =
    usePropertyAdEditorNormalization();

  return (
    <EditorSection
      cardTestId='property-details-card'
      description='Basic information about property'
      title='Property Details'
      titleId='property-details-title'
    >
      <Box
        data-testid='property-details-grid'
        sx={{
          display: 'grid',
          gap: 2.5,
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          minWidth: 0,
          width: '100%',
        }}
      >
        <EditorSelectField
          label='Activity'
          name='activityKind'
          options={activityOptions}
          placeholder='Select activity'
          required
          rules={{ required: 'ActivityKind is a required field' }}
          onValueChange={changeActivity}
        />

        {activityKind === ActivityKindEnum.Sale && (
          <EditorSelectField
            label='Transaction type'
            name='transactionType'
            options={transactionTypeOptions}
            placeholder='Select transaction type'
            required
            rules={{ required: 'Transaction Type is a required field' }}
            onValueChange={changeTransactionType}
          />
        )}

        <EditorSelectField
          label='Property type'
          name='propertyKind'
          options={PROPERTY_AD_EDITOR_PROPERTY_KIND_OPTIONS}
          placeholder='Select property type'
          required
          rules={{ required: 'Property type is a required field' }}
          onValueChange={changePropertyKind}
        />
      </Box>
    </EditorSection>
  );
};
